<template>
  <div>
    <codemirror
      ref="code"
      style="height: auto"
      :value="logs"
      :options="cmOptions"
    />
  </div>
</template>

<script>
import 'codemirror/mode/yaml/yaml'
import 'codemirror/addon/display/autorefresh'

import { codemirror } from 'vue-codemirror'

export default {
  name: 'NotificacaoLog',
  components: {
    codemirror,
  },
  props: ['logs'],
  data() {
    return {
      cmOptions: {
        tabSize: 4,
        mode: 'text/x-yaml',
        highlightDifferences: true,
        readOnly: true,
        theme: 'rubyblue',
        autoRefresh: true,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~codemirror/lib/codemirror.css';
@import '~codemirror/theme/rubyblue.css';

.CodeMirror {
  height: auto !important;
}
</style>
